<template>
  <div class="libox">
    <a class="imgbox" :href="'/albumDetail?albumId='+list.ALBUM_ID" target="_blank">
      <img v-if="list.ALBUM_COVER" :src="list.ALBUM_COVER" alt="">
      <img v-else :src="noIMG" alt="">
    </a>
    <p>
      <a class="titlename1" :href="'/albumDetail?albumId='+list.ALBUM_ID" target="_blank">{{ list.ALBUM_NAME }}</a>
      <a class="titlename2" :href="'/albumDetail?albumId='+list.ALBUM_ID" target="_blank">{{ list.ALBUM_TITLE }}</a>
      <a class="contents" :href="'/albumDetail?albumId='+list.ALBUM_ID" target="_blank">{{ list.ALBUM_ABSTRACT }}</a>
      <span class="hot_time">{{ list.CREATE_DATE|changeTime }}</span>
      <span class="el-icon-view viewNumber">   {{ list.ALBUM_READING_SIZE|changenum }}</span>
      <span class="el-icon-star-on viewNumber viewStar">   {{ list.ALBUM_COLLECTION_SIZE|changenum }}</span>
    </p>
  </div>
</template>

<script>
// ///首页列表模板上中下形式
export default {
  name: 'ListTemolate4',
  props: ['list'],
  data() {
    return {
      noIMG: require('@/static/home_noimg.png')
    }
  },
  methods: {
    goDetail: function(ID) {
      const { href } = this.$router.resolve({
        path: '/albumDetail',
        name: 'abd',
        query: {
          albumId: ID
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .libox{
        display: inline-block;
        width: 392px;
        font-size: 0;
        transition: 0.3s;
        position: relative;
        padding: 9px;
        border: 1px solid #f0f0f0;
        -moz-box-shadow:1px 1px 3px #f3f3f3;
        -webkit-box-shadow:1px 1px 3px #f3f3f3;
        box-shadow:1px 1px 3px #f3f3f3;
        text-align: left;
        .imgbox{
            cursor: pointer;
            display: inline-block;
            width: 162px;
            height: 212px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        p{
            display: inline-block;
            width: 220px;
            height: 212px;
            font-size: 0;
            vertical-align: top;
            margin-left: 10px;
            .titlename1{
              margin-top: 12px;
                cursor: pointer;
                font-size: 18px;
                font-weight: 600;
                color: #333333;
                display: inline-block;
                width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .titlename2{
                font-size: 16px;
                color: #333333;
                width: 100%;
                display: inline-block;
                margin-top: 15px;
              cursor: pointer;
            }
            .contents{
                display:block;
                width: 100%;
                color: #666666;
                font-size: 12px;
                display:-webkit-box;
                -webkit-line-clamp:3;
                -webkit-box-orient:vertical;
                overflow:hidden;
                word-break: break-all;
                height: 48px;
                margin-top: 10px;
                margin-bottom: 50px;
              cursor: pointer;

        }
            .hot_time{
                color: #b2b2b2;
                font-size: 12px;
                display: inline-block;
                margin-right:10px;
            }
            .viewNumber{
                color: #b2b2b2;
                font-size: 12px;
              width: 50px;
              text-align: right;
            }
            .viewStar{
                margin-left: 5px;
            }
        }
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .libox{
        display: block;
        width: auto;
      .imgbox{
        width: 130px;
        height: 182px;
      }
       p{
          width: calc( 100vw - 200px );
         height: 183px;
         .contents{
           margin-bottom: 30px;
         }
       }
    }
    .viewStar{
      display: none!important;
    }
  }
</style>